import { useEffect, useState } from "react";

const STORAGE_KEY = "dd_admin_token_v1";

export const getAdminToken = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.exp && data.exp < Date.now()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data.token;
  } catch {
    return null;
  }
};

export const setAdminToken = (token, expiresIn) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ token, exp: Date.now() + expiresIn * 1000 }),
  );
};

export const clearAdminToken = () => {
  localStorage.removeItem(STORAGE_KEY);
};

const apiBase = () => process.env.REACT_APP_BACKEND_URL || "";

export const adminFetch = async (path, options = {}) => {
  const token = getAdminToken();
  const res = await fetch(`${apiBase()}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-Admin-Token": token || "",
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    clearAdminToken();
    throw new Error("Sesiune expirată. Te rugăm să te loghezi din nou.");
  }
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch {
      // ignore
    }
    throw new Error(detail);
  }
  return res.json();
};

export const useAdminAuth = () => {
  const [authed, setAuthed] = useState(!!getAdminToken());
  useEffect(() => {
    const onStorage = () => setAuthed(!!getAdminToken());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return { authed, setAuthed };
};
